import React from "react";
import "./index.scss";
import {FormControlLabel, Radio, RadioGroup as RadioGroupMui} from "@material-ui/core";
import radioCheckedIcon from "../../../images/radio_checked.svg";
import radioUnCheckedIcon from "../../../images/radio_unchecked.svg";
import {ReactSVG} from "react-svg";

export interface SelectOption {
    label?: string;
    value: any;
}

interface Props {
    options?: SelectOption[];
    value?: string;
    name?: string;
    idPrefix?: string;
    getLabel?: (val: SelectOption) => string;
    onChange?: (value: any) => void;
}

export const RadioGroup = (props: Props) => {
    const {name, value, options, idPrefix, getLabel, onChange} = props;

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        onChange(event.target.value);
    };

    const isIos = /\((iPhone|iPad);/.test(window.navigator.userAgent)

    return (
        <div className='select-one-radio'>
            <RadioGroupMui row={true} className={'select-one-radio-group'} value={value} onChange={handleChange}>

                {Object.entries(options).map(([index,val]) => {
                    return <FormControlLabel
                        id={(idPrefix || name) + '_' + index}
                        value={val.value}
                        key={index}
                        className={`select-one-radio-control-label ${val.value === value ? 'active' : 'inactive'}`}
                        control={
                            <Radio className='select-one-radio-item'
                               icon={  isIos
                                   ? <object className="select-one-radio_ios_costyl" data={radioUnCheckedIcon} type="image/svg+xml"></object>
                                   : <ReactSVG src={radioUnCheckedIcon}/>
                                }
                                   checkedIcon={ isIos
                                   ? <object className="select-one-radio_ios_costyl" data={radioCheckedIcon} type="image/svg+xml"></object>
                                   : <ReactSVG src={radioCheckedIcon}/>
                        } />
                    }
                        label={getLabel ? getLabel(val) : val.label}
                    />
                })}
            </RadioGroupMui>
        </div>
    )
};